import { Pipe, PipeTransform } from '@angular/core';
import { SpousalWaiverTypeEnum } from '../../../models/spousal-waivers/spousal-waiver-type.enum';

@Pipe({
  name: 'spousalWaiverTypeLabel',
  standalone: true
})
export class SpousalWaiverTypeLabelPipe implements PipeTransform {
  transform(value: SpousalWaiverTypeEnum): string {
    if (!value) return '';

    switch (value) {
      case SpousalWaiverTypeEnum.MonthlyPensionSetUp:
        return $localize`Monthly Pension Setup`;
      case SpousalWaiverTypeEnum.VariableBenefitConfiguration:
        return $localize`Variable Benefit Configuration`;
      case SpousalWaiverTypeEnum.PreRetirementBeneficiary:
        return $localize`Pre-Retirement Beneficiary`;
      case SpousalWaiverTypeEnum.VariableBenefitBeneficiary:
        return $localize`Variable Benefit Beneficiary`;
      case SpousalWaiverTypeEnum.MonthlyPensionBeneficiary:
        return $localize`Monthly Pension Beneficiary`;
      case SpousalWaiverTypeEnum.TransferOut:
        return $localize`Transfer Out`;
      case SpousalWaiverTypeEnum.Unlocking:
        return $localize`Unlocking`;
      case SpousalWaiverTypeEnum.SurvivingSpouse:
        return $localize`Surviving Spouse`;
      default:
        return '';
    }
  }
}
